export default class BenefitsBT {

    scroll_benefits = false;

    constructor() {
        this.addEvents();
    }

    addEvents() {
        const that = this;
        const btBenefitsParents = document.querySelectorAll('.bt_benefits');

        if(btBenefitsParents.length > 0) {

            btBenefitsParents.forEach(el => {
                window.addEventListener('scroll', function () {
                    if (window.scrollY >= el.offsetTop+200) {
                        if (!that.scroll_benefits) {
                            that.benefits(el.querySelectorAll('.bt_benefits--number'));
                            that.scroll_benefits = true;
                        }
                    }
                });
            })
        }

    }

    benefits(btBenefitsNumbers){
        const that = this;
        btBenefitsNumbers.forEach(element => {
            const toVal = parseFloat(element.getAttribute('data-to-value'));
            const start = parseFloat(element.getAttribute('data-from-value'));
            that.counter(element, start, toVal, 2000);
        });
    }

    counter(id, start, end, duration) {
        let current = start,
            range = end - start;
        let increment = end > start ? 1 : -1;
        if(end % 1 != 0){
            increment = end > start ? end % 1 : -(end % 1);
        }
        let step = Math.abs(Math.floor(duration / range)),
        timer = setInterval(() => {
            current += increment;
            id.textContent = current;
            if (current == end) {
                clearInterval(timer);
            }
        }, step);
    }

}


